import React from "react";
import { Link } from "react-router-dom";

const EarnMoney = () => {
  return (
    <div className="dg__earn__money">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7">
            <div className="dg__earn__money_inner">
              <h2>Earn Money</h2>
              <p>
                You earn up to 20 TL for each survey you participate in . The
                amount you earn from surveys may vary depending on the number of
                questions in the survey and the subject of the survey. Earnings
                information is given before starting the survey.
              </p>
              <p>
                The high quality of survey results is critical for the companies
                we conduct research. Our experience over time has shown that our
                research with authenticated people has better results. For this
                reason, you must verify your personal information in order to
                earn the full amount of Akçe specified for the survey. Only in
                this way we confirm that you are a real user and only one
                account.
              </p>
              <p>
                With the Invite Survey campaign, you can invite your friend to a
                survey and earn extra income. This campaign is done on some
                surveys. When the campaign is active, a personalized e-mail is
                sent. In addition, there are also surprise campaigns on our site
                from time to time.
              </p>
              <Link
                className="earn__money__btn dg__btn btn--trans"
                to={process.env.PUBLIC_URL + "/faqs"}
              >
                Learn More
              </Link>
            </div>
          </div>
          <div className="col-lg-5">
            <div className="dg__earn__money__thumb">
              <img
                src={process.env.PUBLIC_URL + "/images/home/coin.png"}
                                // src={"https://images.pexels.com/photos/669619/pexels-photo-669619.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"}

                alt="Earn Money"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EarnMoney;
